import React from 'react';

import ModalContentWrapper from '../ModalContentWrapper';
import MemberAccordion from './MemberAccordion';

const ModalTree = ({ title, members }) => {
    return (
        <div className="tree-members">
            <ModalContentWrapper>
                <h3>{title}</h3>
                {members && members.map((member) => 
                    <MemberAccordion key={member.ar_id} member={member} />
                )}
            </ModalContentWrapper>
        </div>
    )
}

export default ModalTree;
